import { useTheme } from "../ThemeProvider/ThemeContext.mjs";
const useSpace = () => useTheme().space;
export {
  useSpace
};
